import { PaymentStatus } from "@gigsync/protocol";
import { localDay } from "../job/when.js";
import { receiptsOf } from "./receipts.js";
import { intoMonths, middayOf, newestFirst, workDay } from "./record.js";
/**
 * What a household paid for its completed work (`done`, from core's `recordsOf`): one row per job, filed by its day
 * the way the worker's record files it, so both sides see a job under the same month.
 */
export function paidRecord(done, payments, me, now, offsetMinutes) {
    const today = localDay(now, offsetMinutes);
    const paid = new Map();
    for (const { payment } of receiptsOf(done, payments, me)) {
        paid.set(payment.engagement, [...(paid.get(payment.engagement) ?? []), payment]);
    }
    const filed = done
        .map((job) => {
        const key = workDay(job, today, offsetMinutes);
        const mine = paid.get(job.engagement.id) ?? [];
        const paid_paise = mine.reduce((sum, p) => sum + p.amount_paise, 0);
        const confirmed = mine.length > 0 && mine.every((p) => p.status === PaymentStatus.enum.confirmed);
        return { key, row: { job, day: middayOf(key, offsetMinutes), paid_paise, confirmed, payments: mine } };
    })
        .sort(newestFirst);
    return { months: intoMonths(filed), paid_paise: filed.reduce((sum, { row }) => sum + row.paid_paise, 0) };
}
//# sourceMappingURL=paid-record.js.map